import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './StockAnalysisDisplayFilter.css'
import StockDisplay from './Stock-Display-table/StockDisplay'
import FilterStock from './Filter-Stock/FilterStock'

const StockAnalysisDisplayFilter = () => {

    const [showFilter, setShowFilter] = useState(true); // Initial state: Filter is visible
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024); // Track if screen is less than 1025px

    useEffect(()=>{
        function handleResize(){
            setIsMobile(window.innerWidth <= 1024);
            if(window.innerWidth >= 1024){setShowFilter(true)}
            else{setShowFilter(setShowFilter(false))}
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize) 
    },[])

    function toggleButton(){
        setShowFilter(!showFilter)
    }


    return (
        <div className='StockAnalysisDisplayFilter-container'>
                {/* {isMobile && (<button className='vertical-text'>show filter</button>)} */}
                {isMobile && (<button type="button" className="btn btn-light m-2" onClick={toggleButton}>{showFilter ? 'Hide Filter' : 'Show Filter'} </button>)}
                <div className={showFilter ? 'StockAnalysisDisplayFilter-Filter' : 'StockAnalysisDisplayFilter-Filter-hide'}>
                <FilterStock />
            </div>
                    
            
            <div className='StockAnalysisDisplayFilter-StockDisplay'>
                <StockDisplay />
            </div>
        </div>
    )
}

export default StockAnalysisDisplayFilter